// function getCookie(name) {
//     const cookieName = `${name}=`;
//     const cookies = document.cookie.split(';');
  
//     // Busca la cookie por su nombre
//     for (let i = 0; i < cookies.length; i++) {
//       let cookie = cookies[i].trim();
//       if (cookie.indexOf(cookieName) === 0) {
//         const cookieValue = cookie.substring(cookieName.length, cookie.length);
//          // Verificar si el nombre de la cookie contiene la palabra "FECHA"
//         if (name.toUpperCase().includes("FECHA")) {
//           const date = new Date(cookieValue);
//           if (isNaN(date.getTime())) {
//             // Si la fecha no es válida, manejar el error aquí
//             console.error("Fecha en la cookie no es válida");
//             return null;
//           }
//         }
//     }
    
//     // Retorna null si no se encuentra la cookie
//     return null;
//   }
  
//   export default getCookie;
function getCookie(name) {
  const cookieName = `${name}=`;
  const cookies = document.cookie.split(';');
  
  // Busca la cookie por su nombre
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      const cookieValue = cookie.substring(cookieName.length, cookie.length);
      //console.log("cookieValue", cookieValue);
      // Verificar si el nombre de la cookie contiene la palabra "FECHA"
      if (name.toUpperCase().includes("FECHA")) {
        //console.log("entre");
        const date = new Date(cookieValue);
        if (isNaN(date.getTime())) {
          // Si la fecha no es válida, manejar el error aquí
          //console.error("Fecha en la cookie no es válida");
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          return null;
        }
      }
      
      return cookieValue;
    }
  }
  
  // Retorna null si no se encuentra la cookie
  return null;
}

export default getCookie;
